const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
const STORAGE_KEY = "upsite_utm";

/** Save UTM params from URL to sessionStorage (call once on app load) */
export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const hasUtm = UTM_KEYS.some((k) => params.has(k));
  if (hasUtm) {
    const utm: Record<string, string> = {};
    for (const key of UTM_KEYS) {
      utm[key] = params.get(key) || "";
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  }
}

/** Get stored UTM params + current page URL for form submission */
export function getTrackingData(source: "contact" | "home") {
  let utm: Record<string, string> = {};
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) utm = JSON.parse(stored);
  } catch {}

  return {
    source,
    pageUrl: window.location.href,
    utmSource: utm.utm_source || "",
    utmMedium: utm.utm_medium || "",
    utmCampaign: utm.utm_campaign || "",
    utmTerm: utm.utm_term || "",
    utmContent: utm.utm_content || "",
  };
}
